import { historicalImportContracts } from "./historical-import.contract";
import { historicalPaymentImportContracts } from "./historical-payment-import.contract";
import { historicalReportedImportContracts } from "./historical-reported-import.contract";

import { growthBaselineSuggestionContracts } from "./growth-baseline-suggestion.contract";
import { rebateTransactionRecordsContracts } from "./rebate-invoices.contract";
import { agreementsContracts } from "./agreements.contract";
import { forecastContracts } from "./forecast.contract";
import { rebateCsvTransformContracts } from "./csv-transform.contract";
import { vendorFollowupContracts } from "./vendor-followup.contract";
import { budgetComparisonContracts } from "./budget-comparison.contract";

export const rebatesContracts = {
  historicalImport: historicalImportContracts,
  historicalPaymentImport: historicalPaymentImportContracts,
  historicalReportedImport: historicalReportedImportContracts,

  growthBaselineSuggestion: growthBaselineSuggestionContracts,
  transactionRecords: rebateTransactionRecordsContracts,
  agreements: agreementsContracts,
  forecast: forecastContracts,
  csvTransform: rebateCsvTransformContracts,
  vendorFollowup: vendorFollowupContracts,
  budgetComparison: budgetComparisonContracts,
} as const;

// Re-export types and schemas
export * from "./historical-import.contract";
export * from "./historical-payment-import.contract";
export * from "./historical-reported-import.contract";

export * from "./growth-baseline-suggestion.contract";
export * from "./rebate-invoices.contract";
export * from "./rebate-rule.schema";
export * from "./agreements.contract";
export * from "./forecast.contract";
export * from "./csv-transform.contract";
export * from "./vendor-followup.contract";
export * from "./budget-comparison.contract";
